import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSidebarBottomTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="none"
    viewBox="0 0 218 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="#F2F2F2" fillRule="evenodd">
      <path
        d="M.33-.153v1.154a5.65 5.65 0 0 0 5.138 5.626l103.426 9.504 103.63-9.504A5.65 5.65 0 0 0 217.664 1V-.153H.33Z"
        stroke="#C2C5CC"
        strokeWidth={0.7}
      />
      <path d="M.682-2h216.63v3H.682z" />
    </g>
  </svg>
);
const Memo = memo(SvgSidebarBottomTriangle);
export default Memo;
